export default __webpack_public_path__ + "static/media/car10.d77f20e8.png";